import { appConfig } from '../../../../config';
import { http } from '../../../../api/axios';

export const neverShowTutorialAgain = () => {
    return http.put(appConfig().endpointTutorial, { showIntroVideo: false }).then(() => {});
};
